import EditProfileForm from '../../../forms/editProfile/EditProfileForm';
import DefaultModal from '../defaultModal/DefaultModal';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';

function EditProfileModal({
  formOptions,
  showEditProfile,
  setShowEditProfile,
  errors,
  handleSubmit,
  form,
  setErrors,
}) {
  const { width } = useWindowDimensions();
  const { trans, configInfo } = useTranslation();

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultModal
      show={width >= 1024 && showEditProfile}
      setShow={setShowEditProfile}
      className="edit-profile"
      width={1016}
      centered
    >
      <div className="flex justify-between items-center pb-[50px]">
        <h1 className="m-0 text-4xl">{trans('edit_profile')}</h1>
        {isGeorgia ? <GRLogo />
          : (
            <img
              src="/ticketLogos/mobileLogoArm.png"
              alt="Armenia Railway Logo"
              width={90}
              height={42}
            />
          )}
      </div>
      <EditProfileForm
        errors={errors}
        options={formOptions}
        handleSubmit={handleSubmit}
        form={form}
        setErrors={setErrors}
      />
    </DefaultModal>
  );
}

export default EditProfileModal;
